import { update } from "@/api/rest";

const briefcaseProjectIndex = {
  updateCompleted: async (data) => await update('/briefcase-project-index/update-completed', data),
};

export default briefcaseProjectIndex;